import React from 'react';
import { PropTypes } from 'prop-types';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import FormViewButton from 'components/Common/Buttons/FormViewButton';

// eslint-disable-next-line import/prefer-default-export
export const ReceivedFormActionsCellRenderer = ({
  value: id,
  data: form,
  context: {
    settings,
    permissions,
    deleteFormCallback,
    addBeneficiaryFormCallback,
    showAccountWithholdingCallback,
    editCustomerLegalEntitiesCallback
  }
}) => (
  <div className="form-action-btn-group">
    {
      (
        (form.isOnlineForm
          && AccessControl.hasPermission(
            permissions,
            [
              ActivityPerms.electronicView,
              ActivityPerms.electronicValidate
            ]
          )
        ) || (
          !form.isOnlineForm
          && AccessControl.hasPermission(
            permissions,
            [
              ActivityPerms.scannedView,
              ActivityPerms.scannedEdit,
              ActivityPerms.scannedValidate
            ]
          )
          && form.formType
          && form.formType.toLowerCase() !== 'unknown'
        )
      ) && <FormViewButton
        permissions={ permissions }
        formId={ form.id }
        form={ form }
        content={ <span className="icon icon-apps" /> }
        className="btn btn-sm"
        title="Reopen"
      />
    }
    { (
      !form.isOnlineForm
        && AccessControl.hasPermission(
          permissions,
          [
            ActivityPerms.scannedUpload,
            ActivityPerms.scannedEdit,
            ActivityPerms.scannedValidate
          ],
          true
        )
    ) && (form.formType != null && form.formType.toLowerCase().indexOf('w8imy') >= 0)
      && (form.hasParentForm || (form.hasAllocationStmt && form.allocationStmtType
      && form.allocationStmtType.toLowerCase().indexOf('pooled') === -1))
      && <span><button
        className="btn btn-sm "
        onClick={ () => addBeneficiaryFormCallback(form) }
        type="button"
        title="Add Layer"
      >
        <span className="icon icon-upload" /></button></span> }
    { (settings && settings.showWithholding && AccessControl.hasPermission(permissions, [ActivityPerms.whdViewRates]))
      && form.accountId && !form.hasParentForm && <span><button
        className="btn btn-sm "
        onClick={ () => showAccountWithholdingCallback(form) }
        type="button"
        title="Show Withholding Rates"
      >
        <span className="icon icon-calculator" />
      </button></span> }
    { (settings && form.customerId && form.customerId !== ''
        && (
          (form.isOnlineForm
            && AccessControl.hasPermission(
              permissions,
              [
                ActivityPerms.electronicView,
                ActivityPerms.electronicValidate
              ]
            )
          ) || (
            !form.isOnlineForm
            && AccessControl.hasPermission(
              permissions,
              [
                ActivityPerms.scannedView,
                ActivityPerms.scannedEdit,
                ActivityPerms.scannedValidate
              ]
            )
            && form.formType
            && form.formType.toLowerCase() !== 'unknown'
          )
        )
    ) && <span><button
      className="btn btn-sm "
      onClick={ () => editCustomerLegalEntitiesCallback(form) }
      type="button"
      title="Edit Legal Entity"
    >
      <span className="icon icon-edit" />
    </button></span> }
    { ((form.isOnlineForm && AccessControl.hasPermission(
      permissions,
      [
        ActivityPerms.electronicDelete
      ]
    )
    )
      || (
        !form.isOnlineForm
          && AccessControl.hasPermission(
            permissions,
            [
              ActivityPerms.scannedDelete
            ]
          )
          && form.formType
          && form.formType.toLowerCase() !== 'unknown'
      )
    ) && <button
      className="btn btn-sm btn-danger"
      onClick={ () => deleteFormCallback(form) }
      type="button"
      title="Delete form"
    >
      <span className="icon icon-delete" />
      </button> }
  </div>
);

ReceivedFormActionsCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  data: PropTypes.shape({
    formType: PropTypes.string,
    isOnlineForm: PropTypes.bool
  }).isRequired,
  context: PropTypes.shape({
    permissions: PropTypes.arrayOf(PropTypes.string),
    deleteFormCallback: PropTypes.func,
    addBeneficiaryFormCallback: PropTypes.func,
    editCustomerLegalEntitiesCallback: PropTypes.func,
    showAccountWithholdingCallback: PropTypes.func,
    settings: PropTypes.shape({
      showWithholding: PropTypes.bool
    })
  })
};

ReceivedFormActionsCellRenderer.defaultProps = {
  context: {}
};
